<template>

  <section class="section">


    <div class="columns is-centered">

      <div class="tabs cities">

        <div class="column cities">
          <a v-on:click="setActive('Alle')" v-bind:class="{ 'is-active': isActive('Alle')}" class="workout-type">Alle</a>
        </div>

        <div class="column cities">
          <a v-on:click="setActive('Yoga')" v-bind:class="{ 'is-active': isActive('Yoga')}" class="workout-type">Yoga</a>
        </div>

        <div class="column cities">
          <a v-on:click="setActive('Pilates')" v-bind:class="{ 'is-active': isActive('Pilates')}" class="workout-type">Pilates</a>
        </div>

        <div class="column cities">
          <a v-on:click="setActive('Climb')" v-bind:class="{ 'is-active': isActive('Climb')}" class="workout-type">Klatring</a>
        </div>

        <div class="column cities">
          <a v-on:click="setActive('Swim')" v-bind:class="{ 'is-active': isActive('Swim')}" class="workout-type">Svømming</a>
        </div>

        <div class="column cities">
          <a v-on:click="setActive('Fight')" v-bind:class="{ 'is-active': isActive('Fight')}" class="workout-type">Kampsport</a>
        </div>

        <div class="column cities">
          <a v-on:click="setActive('Strength')" v-bind:class="{ 'is-active': isActive('Strength')}" class="workout-type">Styrke</a>
        </div>

      </div>

    </div>


    <!--
    <div class="container taster-dates" id="classes">

    <!-- First Week --
    <div v-if="isActiveWeek('firstWeek')" class="tabs is-centered dates">
    <ul>
    <div v-on:click="previousWeek()" class="button" id="btn-weeks" v-bind:html="{ 'disabled': isActiveWeek('firstWeek')}"><i class="fas fa-angle-left fa-lg"></i> </div>
    <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Mandag')" v-bind:class="{ 'is-active': isActiveDay('Mandag')}"><a>{{ dateNumber }}<br>{{ day }}</a></li>
    <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Tirsdag')" v-bind:class="{ 'is-active': isActiveDay('Tirsdag')}"><a>{{ dateNumberTomorrow }}<br>{{ dayTomorrow }}</a></li>
    <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Onsdag')" v-bind:class="{ 'is-active': isActiveDay('Onsdag')}"><a>{{ dateNumberThirdday }}<br>{{ dayThirdday }}</a></li>
    <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Torsdag')" v-bind:class="{ 'is-active': isActiveDay('Torsdag')}"><a>{{ dateNumberFourthday }}<br>{{ dayFourthday }}</a></li>
    <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Fredag')" v-bind:class="{ 'is-active': isActiveDay('Fredag')}"><a>{{ dateNumberFifthday }}<br>{{ dayFifthday }}</a></li>
    <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Lørdag')" v-bind:class="{ 'is-active': isActiveDay('Lørdag')}"><a>{{ dateNumberSixthday }}<br>{{ daySixthday }}</a></li>
    <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Søndag')" v-bind:class="{ 'is-active': isActiveDay('Søndag')}"><a>{{ dateNumberSeventhday }}<br>{{ daySeventhday }}</a></li>
    <div v-on:click="nextWeek()" class="button" id="btn-weeks"><i class="fas fa-angle-right fa-lg"></i></div>
  </ul>
</div>

<!-- Second Week --
<div v-if="isActiveWeek('secondWeek')" class="tabs is-centered dates">
<ul>
<div v-on:click="previousWeek()" class="button" id="btn-weeks"><i class="fas fa-angle-left fa-lg"></i> </div>
<li class ="has-text-centered workout-date" v-on:click="setActiveDay('Mandag')" v-bind:class="{ 'is-active': isActiveDay('Mandag')}"><a>{{ sw_dateNumber }}<br>{{ sw_day }}</a></li>
<li class ="has-text-centered workout-date" v-on:click="setActiveDay('Tirsdag')" v-bind:class="{ 'is-active': isActiveDay('Tirsdag')}"><a>{{ sw_dateNumberTomorrow }}<br>{{ sw_dayTomorrow }}</a></li>
<li class ="has-text-centered workout-date" v-on:click="setActiveDay('Onsdag')" v-bind:class="{ 'is-active': isActiveDay('Onsdag')}"><a>{{ sw_dateNumberThirdday }}<br>{{ sw_dayThirdday }}</a></li>
<li class ="has-text-centered workout-date" v-on:click="setActiveDay('Torsdag')" v-bind:class="{ 'is-active': isActiveDay('Torsdag')}"><a>{{ sw_dateNumberFourthday }}<br>{{ sw_dayFourthday }}</a></li>
<li class ="has-text-centered workout-date" v-on:click="setActiveDay('Fredag')" v-bind:class="{ 'is-active': isActiveDay('Fredag')}"><a>{{ sw_dateNumberFifthday }}<br>{{ sw_dayFifthday }}</a></li>
<li class ="has-text-centered workout-date" v-on:click="setActiveDay('Lørdag')" v-bind:class="{ 'is-active': isActiveDay('Lørdag')}"><a>{{ sw_dateNumberSixthday }}<br>{{ sw_daySixthday }}</a></li>
<li class ="has-text-centered workout-date" v-on:click="setActiveDay('Søndag')" v-bind:class="{ 'is-active': isActiveDay('Søndag')}"><a>{{ sw_dateNumberSeventhday }}<br>{{ sw_daySeventhday }}</a></li>
<div v-on:click="nextWeek()" class="button" id="btn-weeks"><i class="fas fa-angle-right fa-lg"></i></div>
</ul>
</div>
</div>

<!--DAYS TABS
<!--Monday first week
<div class="container" v-if="isActiveDay('Mandag')" id="workout-card">

<div class="columns is-multiline has-text-centered">

<div v-for="(workout, index) in workouts" v-if="today(workout) && activeDay === 'Mandag' && (activeType === workout.type || activeType === 'Alle')" class="column is-one-quarter classes" id="workout-column">
<h1 id="workout-name">{{workout.name}}</h1>
<h2 id="workout-type">{{workout.type}}</h2>
<p id="workout-places">Ledige plasser: {{workout.places_left}}</p>
<a class="button" v-if= "!userAlreadySignedup" v-on:click="removePlace(index, workout)" id="meldon">Meld på</a>
</div>

</div>

</div>
<!--Tuesday first week
<div class="container" v-if="isActiveDay('Tirsdag')" id="workout-card">


<div class="columns is-multiline has-text-centered">

<div v-for="(workout, index) in workouts" v-if="tomorrow(workout) && activeDay === 'Tirsdag' && (activeType === workout.type || activeType === 'Alle')" class="column is-one-quarter classes">
<h1>{{workout.name}}</h1>
<h2>{{workout.type}}</h2>
<p>Ledige plasser: {{workout.places_left}}</p>
<a class="button" v-if= "!userAlreadySignedup" v-on:click="removePlace(index, workout)" id="meldon">Meld på</a>
</div>

</div>

</div>
<!--Wednesday first week
<div class="container" v-if="isActiveDay('Onsdag')" id="workout-card">
<div class="columns is-multiline has-text-centered">
<div v-for="(workout, index) in workouts" v-if="thirdday(workout) && activeDay === 'Onsdag' && (activeType === workout.type || activeType === 'Alle')" class="column is-one-quarter classes">
<h1>{{workout.name}}</h1>
<h2>{{workout.type}}</h2>
<p>Ledige plasser: {{workout.places_left}}</p>
<a class="button" v-if= "!userAlreadySignedup" v-on:click="removePlace(index, workout)" id="meldon">Meld på</a>
</div>
</div>
</div>
<!--Thursdayfirst week--
<div class="container" v-if="isActiveDay('Torsdag')" id="workout-card">
<div class="columns is-multiline has-text-centered">
<div v-for="(workout, index) in workouts" v-if="fourthday(workout) && activeDay === 'Torsdag' && (activeType === workout.type || activeType === 'Alle')" class="column is-one-quarter classes">
<h1>{{workout.name}}</h1>
<h2>{{workout.type}}</h2>
<p>Ledige plasser: {{workout.places_left}}</p>
<a class="button" v-if= "!userAlreadySignedup" v-on:click="removePlace(index, workout)" id="meldon">Meld på</a>
</div>
</div>
</div>
<!--Friday first week--
<div class="container" v-if="isActiveDay('Fredag')" id="workout-card">
<div class="columns is-multiline has-text-centered">
<div v-for="(workout, index) in workouts" v-if="fifthday(workout) && activeDay === 'Fredag' && (activeType === workout.type || activeType === 'Alle')" class="column is-one-quarter classes">
<h1>{{workout.name}}</h1>
<h2>{{workout.type}}</h2>
<p>Ledige plasser: {{workout.places_left}}</p>
<a class="button" v-if= "!userAlreadySignedup" v-on:click="removePlace(index, workout)" id="meldon">Meld på</a>
</div>
</div>
</div>
<!--Saturday first week--
<div class="container" v-if="isActiveDay('Lørdag')" id="workout-card">
<div class="columns is-multiline has-text-centered">
<div v-for="(workout, index) in workouts" v-if="sixthday(workout) && activeDay === 'Lørdag' && (activeType === workout.type || activeType === 'Alle')" class="column is-one-quarter classes">
<h1>{{workout.name}}</h1>
<h2>{{workout.type}}</h2>
<p>Ledige plasser: {{workout.places_left}}</p>
<a class="button" v-if= "!userAlreadySignedup" v-on:click="removePlace(index, workout)" id="meldon">Meld på</a>
</div>
</div>
</div>
<!--Sunday first week
<div class="container" v-if="isActiveDay('Søndag')" id="workout-card">
<div class="columns is-multiline has-text-centered">
<div v-for="(workout, index) in workouts" v-if="seventhday(workout) && activeDay === 'Søndag' && (activeType === workout.type || activeType === 'Alle')" class="column is-one-quarter classes">
<h1>{{workout.name}}</h1>
<h2>{{workout.type}}</h2>
<p>Ledige plasser: {{workout.places_left}}</p>
<a class="button" v-if= "!userAlreadySignedup" v-on:click="removePlace(index, workout)" id="meldon">Meld på</a>
</div>
</div>
</div>


<!--END DAYS TABS-->

<!-- Delete Class Modal -->
<div class="modal" v-bind:class="{ 'is-active': showDeleteModal}">
  <div class="modal-background"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Er du sikker på at du ønsker å slette timen?</p>
      <button class="delete" v-on:click="showDeleteModal = false" aria-label="close"></button>
    </header>
    <section class="modal-card-body">
      <p>Dersom du sletter timen, vil alle deltakere bli fjernet. Det er ikke mulig å gjenopprette timen.</p>
    </section>
    <footer class="modal-card-foot">
      <button class="button is-danger" v-on:click="deleteClass()">Ja, slett timen</button>
      <button class="button" v-on:click="showDeleteModal = false">Avbryt</button>
    </footer>
  </div>
</div>

<!-- Successful Class Signup Modal -->
<div class="modal" v-bind:class="{ 'is-active': showSuccessModal}">
  <div class="modal-background"></div>
  <div class="modal-card">

    <button class="delete" v-on:click="showSuccessModal = false" aria-label="close"></button>

    <section class="modal-card-body">
      <p>Grattis, vi gleder oss til å se deg på timen!</p>
    </section>
    <button class="button is-success" v-on:click="showSuccessModal = false">Lukk</button>
  </div>
</div>











<div class="container taster-dates" id="classes">

  <!-- First Week -->
  <div v-if="isActiveWeek('firstWeek')" class="tabs is-centered dates">
    <ul>
      <div v-on:click="previousWeek()" class="button" id="btn-weeks" v-bind:html="{ 'disabled': isActiveWeek('firstWeek')}"><i class="fas fa-angle-left fa-lg"></i> </div>
      <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Mandag')" v-bind:class="{ 'is-active': isActiveDay('Mandag')}"><a>{{ dateNumber }}<br>{{ day }}</a></li>
      <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Tirsdag')" v-bind:class="{ 'is-active': isActiveDay('Tirsdag')}"><a>{{ dateNumberTomorrow }}<br>{{ dayTomorrow }}</a></li>
      <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Onsdag')" v-bind:class="{ 'is-active': isActiveDay('Onsdag')}"><a>{{ dateNumberThirdday }}<br>{{ dayThirdday }}</a></li>
      <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Torsdag')" v-bind:class="{ 'is-active': isActiveDay('Torsdag')}"><a>{{ dateNumberFourthday }}<br>{{ dayFourthday }}</a></li>
      <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Fredag')" v-bind:class="{ 'is-active': isActiveDay('Fredag')}"><a>{{ dateNumberFifthday }}<br>{{ dayFifthday }}</a></li>
      <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Lørdag')" v-bind:class="{ 'is-active': isActiveDay('Lørdag')}"><a>{{ dateNumberSixthday }}<br>{{ daySixthday }}</a></li>
      <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Søndag')" v-bind:class="{ 'is-active': isActiveDay('Søndag')}"><a>{{ dateNumberSeventhday }}<br>{{ daySeventhday }}</a></li>
      <div v-on:click="nextWeek()" class="button" id="btn-weeks"><i class="fas fa-angle-right fa-lg"></i></div>
    </ul>
  </div>

  <!-- Second Week -->
  <div v-if="isActiveWeek('secondWeek')" class="tabs is-centered dates">
    <ul>
      <div v-on:click="previousWeek()" class="button" id="btn-weeks"><i class="fas fa-angle-left fa-lg"></i> </div>
      <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Mandag')" v-bind:class="{ 'is-active': isActiveDay('Mandag')}"><a>{{ sw_dateNumber }}<br>{{ sw_day }}</a></li>
      <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Tirsdag')" v-bind:class="{ 'is-active': isActiveDay('Tirsdag')}"><a>{{ sw_dateNumberTomorrow }}<br>{{ sw_dayTomorrow }}</a></li>
      <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Onsdag')" v-bind:class="{ 'is-active': isActiveDay('Onsdag')}"><a>{{ sw_dateNumberThirdday }}<br>{{ sw_dayThirdday }}</a></li>
      <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Torsdag')" v-bind:class="{ 'is-active': isActiveDay('Torsdag')}"><a>{{ sw_dateNumberFourthday }}<br>{{ sw_dayFourthday }}</a></li>
      <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Fredag')" v-bind:class="{ 'is-active': isActiveDay('Fredag')}"><a>{{ sw_dateNumberFifthday }}<br>{{ sw_dayFifthday }}</a></li>
      <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Lørdag')" v-bind:class="{ 'is-active': isActiveDay('Lørdag')}"><a>{{ sw_dateNumberSixthday }}<br>{{ sw_daySixthday }}</a></li>
      <li class ="has-text-centered workout-date" v-on:click="setActiveDay('Søndag')" v-bind:class="{ 'is-active': isActiveDay('Søndag')}"><a>{{ sw_dateNumberSeventhday }}<br>{{ sw_daySeventhday }}</a></li>
      <div v-on:click="nextWeek()" class="button" id="btn-weeks"><i class="fas fa-angle-right fa-lg"></i></div>
    </ul>
  </div>
</div>


<!--DAYS TABLE-->
<!--Monday first week-->
<table class="table is-striped is-hoverable" v-if="isActiveDay('Mandag')" id="workout-table">

  <tr v-for="(workout, index) in workouts_sorted_time" v-if="today(workout) && activeDay === 'Mandag' && (activeType === workout.type || activeType === 'Alle')" id="workout-column">
    <th id="workout-time">{{workout.time}}</th>
    <td id="workout-name"><a @click="showClassModal(index)">{{workout.name}}</a></td>
    <td id="workout-studio">{{workout.studio}}</td>
    <td id="workout-type">{{workout.type}}</td>
    <td id="workout-places">Ledige plasser: {{workout.places_left}}</td>
    <td><a class="button" href="/sign-up" id="meldon">Meld på</a></td>
  </tr>

</table>

<table class="table is-striped is-hoverable" v-if="isActiveDay('Tirsdag')" id="workout-table">

  <tr v-for="(workout, index) in workouts_sorted_time" v-if="tomorrow(workout) && activeDay === 'Tirsdag' && (activeType === workout.type || activeType === 'Alle')" id="workout-column">
    <th id="workout-time">{{workout.time}}</th>
    <td id="workout-name">{{workout.name}}</td>
    <td id="workout-type">{{workout.type}}</td>
    <td id="workout-places">Ledige plasser: {{workout.places_left}}</td>
    <td><a class="button" href="/sign-up" id="meldon">Meld på</a></td>
  </tr>

</table>




<div class="modal" v-bind:class="{ 'is-active': showClassModal}">
  <div class="modal-background"></div>
  <div class="modal-card">

    <button class="delete" v-on:click="showSuccessModal = false" aria-label="close"></button>

    <section class="modal-card-body">
      <p>Dette er time modalen</p>
    </section>
    <button class="button is-success" v-on:click="showSuccessModal = false">Lukk</button>
  </div>
</div>




</section>
</template>

<script>
import Firebase from 'firebase'


export default {


  data() {
    return {

      activeType: 'Alle',
      activeDay: 'Mandag',
      activeDate: '',

      dateNumber: '',
      dateNumberTomorrow: '',
      dateNumberThirdday: '',
      dateNumberFourthday: '',
      dateNumberFifthday: '',
      dateNumberSixthday: '',
      dateNumberSeventhday: '',
      day: '',

      showDeleteModal: false,
      toDelete: '',
      showSuccessModal: false,
      userAlreadySignedup: false,

      activeWeek: 'firstWeek',

      workouts: '',

    }
  },

  methods: {
    isActiveWeek: function(week){
      return this.activeWeek === week
    },
    nextWeek: function(){
      if(this.activeWeek === 'firstWeek') {this.activeWeek = 'secondWeek'} else {alert("Already at last week!")}
    },
    previousWeek: function (){
      if(this.activeWeek === 'secondWeek') {this.activeWeek = 'firstWeek'} else {alert('Already at first week!')}
    },
    activateDeleteModal: function(index) {
      this.showDeleteModal = true;
      this.toDelete = index;
    },
    deleteClass: function() {
      var wo = Firebase.database().ref('workouts/'+this.toDelete);
      wo.remove();
      this.showDeleteModal = false;
    },

    removeWorkout: function (index) {
      var wo = Firebase.database().ref('workouts/'+index);
      wo.remove();
    },
    removePlace: function(index, workout) {
      var wo = Firebase.database().ref('workouts/'+index);
      if(workout.places_left >= 1) { var new_places = workout.places_left - 1} else {alert("Ingen ledige plasser!")};
      wo.update({places_left: new_places});
      this.showSuccessModal = true;
    },
    today: function(workout) {
      var date = new Date();
      var dd = date.getDate();
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var todaysDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === todaysDate) { return true };
    },
    tomorrow: function(workout) {
      var date = new Date();
      var dd = date.getDate()+1;
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var tomorrowsDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === tomorrowsDate) { return true };
    },
    thirdday: function(workout) {
      var date = new Date();
      var dd = date.getDate()+2;
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var thirddayDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === thirddayDate) { return true };
    },
    fourthday: function(workout) {
      var date = new Date();
      var dd = date.getDate()+3;
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var fourthdayDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === fourthdayDate) { return true };
    },
    fifthday: function(workout) {
      var date = new Date();
      var dd = date.getDate()+4;
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var fifthdayDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === fifthdayDate) { return true };
    },
    sixthday: function(workout) {
      var date = new Date();
      var dd = date.getDate()+5;
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var sixthdayDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === sixthdayDate) { return true };
    },
    seventhday: function(workout) {
      var date = new Date();
      var dd = date.getDate()+6;
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var seventhdayDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === seventhdayDate) { return true };
    },

    //Next week
    sw_today: function(workout) {
      var date = new Date();
      var dd = date.getDate()+6;
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var sw_todaysDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === sw_todaysDate) { return true };
    },
    sw_tomorrow: function(workout) {
      var date = new Date();
      var dd = date.getDate()+7;
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var sw_tomorrowsDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === sw_tomorrowsDate) { return true };
    },
    sw_thirdday: function(workout) {
      var date = new Date();
      var dd = date.getDate()+8;
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var sw_thirddayDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === sw_thirddayDate) { return true };
    },
    sw_fourthday: function(workout) {
      var date = new Date();
      var dd = date.getDate()+9;
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var sw_fourthdayDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === sw_fourthdayDate) { return true };
    },
    sw_fifthday: function(workout) {
      var date = new Date();
      var dd = date.getDate()+10;
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var sw_fifthdayDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === sw_fifthdayDate) { return true };
    },
    sw_sixthday: function(workout) {
      var date = new Date();
      var dd = date.getDate()+11;
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var sw_sixthdayDate = yyyy+'-'+mm+'-'+dd;

      if(workout.date === sw_sixthdayDate) { return true };
    },


    //Date functions
    todayDate: function() {
      var date = new Date();
      var dd = date.getDate();
      var mm = date.getMonth()+1;
      var yyyy = date.getFullYear();
      if (mm < 10) {mm = '0'+mm};
      if (dd < 10) {dd = '0'+dd};
      var todaysDate = yyyy+'-'+mm+'-'+dd;
      this.activeDate = todaysDate;

      if(this.activeDate === todaysDate) { return true };
    },

    isActive: function(type) {
      return this.activeType === type
    },
    setActive: function (type) {
      this.activeType = type
    },
    isActiveDay: function (weekday) {
      return this.activeDay === weekday
    },
    setActiveDay: function (day) {
      this.activeDay = day
    }
  },

  created() {
    var db = Firebase.database();
    var workoutss = this.$bindAsObject('workouts', db.ref('workouts/'));
    this.workouts = workoutss;
    //Todays date and days for whole row
    var date = new Date();
    var dd = date.getDate();
    var thisday = date.getDay();

    if (thisday === 1) { this.day = 'Mandag'; this.dayTomorrow = 'Tirsdag'; this.dayThirdday = 'Onsdag'; this.dayFourthday = 'Torsdag'; this.dayFifthday = 'Fredag'; this.daySixthday = 'Lørdag'; this.daySeventhday = 'Søndag' }
    else if (thisday === 2) { this.day = 'Tirsdag'; this.dayTomorrow = 'Onsdag'; this.dayThirdday = 'Torsdag'; this.dayFourthday = 'Fredag'; this.dayFifthday = 'Lørdag'; this.daySixthday = 'Søndag'; this.daySeventhday = 'Mandag' }
    else if (thisday === 3) { this.day = 'Onsdag'; this.dayTomorrow = 'Torsdag'; this.dayThirdday = 'Fredag'; this.dayFourthday = 'Lørdag'; this.dayFifthday = 'Søndag'; this.daySixthday = 'Mandag'; this.daySeventhday = 'Tirsdag' }
    else if (thisday === 4) { this.day = 'Torsdag'; this.dayTomorrow = 'Fredag'; this.dayThirdday = 'Lørdag'; this.dayFourthday = 'Søndag'; this.dayFifthday = 'Mandag'; this.daySixthday = 'Tirsdag'; this.daySeventhday = 'Onsdag' }
    else if (thisday === 5) { this.day = 'Fredag'; this.dayTomorrow = 'Lørdag'; this.dayThirdday = 'Søndag'; this.dayFourthday = 'Mandag'; this.dayFifthday = 'Tirsdag'; this.daySixthday = 'Onsdag'; this.daySeventhday = 'Torsdag' }
    else if (thisday === 6) { this.day = 'Lørdag'; this.dayTomorrow = 'Søndag'; this.dayThirdday = 'Mandag'; this.dayFourthday = 'Tirsdag'; this.dayFifthday = 'Onsdag'; this.daySixthday = 'Torsdag'; this.daySeventhday = 'Fredag' }
    else if (thisday === 0) { this.day = 'Søndag'; this.dayTomorrow = 'Mandag'; this.dayThirdday = 'Tirsdag'; this.dayFourthday = 'Onsdag'; this.dayFifthday = 'Torsdag'; this.daySixthday = 'Fredag'; this.daySeventhday = 'Lørdag' };

    var mm = date.getMonth()+1;

    this.dateNumber = dd+'.'+mm;
    //Tomorrows date showed in table
    var to = new Date();
    to.setDate(to.getDate()+1);
    var tomorrow_dd = to.getDate();
    var tomorrow_mm = to.getMonth()+1;
    var tomorrowsDateNumber = tomorrow_dd+'.'+tomorrow_mm;
    this.dateNumberTomorrow = tomorrowsDateNumber;
    //Third days date showed in table
    var th = new Date();
    th.setDate(th.getDate()+2);
    var th_dd = th.getDate();
    var th_mm = th.getMonth()+1;
    var thDateNumber = th_dd+'.'+th_mm;
    this.dateNumberThirdday = thDateNumber;
    //Fourth days date showed in table
    var fh = new Date();
    fh.setDate(fh.getDate()+3);
    var fh_dd = fh.getDate();
    var fh_mm = fh.getMonth()+1;
    var fhDateNumber = fh_dd+'.'+fh_mm;
    this.dateNumberFourthday = fhDateNumber;
    //Fifth date showed in table
    var fi = new Date();
    fi.setDate(fi.getDate()+4);
    var fi_dd = fi.getDate();
    var fi_mm = fi.getMonth()+1;
    var fiDateNumber = fi_dd+'.'+fi_mm;
    this.dateNumberFifthday = fiDateNumber;
    //Sixth date showed in table
    var si = new Date();
    si.setDate(si.getDate()+5);
    var si_dd = si.getDate();
    var si_mm = si.getMonth()+1;
    var siDateNumber = si_dd+'.'+si_mm;
    this.dateNumberSixthday = siDateNumber;

    var sev = new Date();
    sev.setDate(sev.getDate()+6);
    var sev_dd = sev.getDate();
    var sev_mm = sev.getMonth()+1;
    var sevDateNumber = sev_dd+'.'+sev_mm;
    this.dateNumberSeventhday = sevDateNumber;

    //Next week and next weeks days
    //Todays date and days for whole row
    var sw_date = new Date();
    sw_date.setDate(sw_date.getDate()+7);
    var sw_dd = sw_date.getDate();
    var sw_thisday = sw_date.getDay();

    if (sw_thisday === 1) { this.sw_day = 'Mandag'; this.sw_dayTomorrow = 'Tirsdag'; this.sw_dayThirdday = 'Onsdag'; this.sw_dayFourthday = 'Torsdag'; this.sw_dayFifthday = 'Fredag'; this.sw_daySixthday = 'Lørdag'; this.sw_daySeventhday = 'Søndag' }
    else if (sw_thisday === 2) { this.sw_day = 'Tirsdag'; this.sw_dayTomorrow = 'Onsdag'; this.sw_dayThirdday = 'Torsdag'; this.sw_dayFourthday = 'Fredag'; this.sw_dayFifthday = 'Lørdag'; this.sw_daySixthday = 'Søndag'; this.sw_daySeventhday = 'Mandag' }
    else if (sw_thisday === 3) { this.sw_day = 'Onsdag'; this.sw_dayTomorrow = 'Torsdag'; this.sw_dayThirdday = 'Fredag'; this.sw_dayFourthday = 'Lørdag'; this.sw_dayFifthday = 'Søndag'; this.sw_daySixthday = 'Mandag'; this.sw_daySeventhday = 'Tirsdag' }
    else if (sw_thisday === 4) { this.sw_day = 'Torsdag'; this.sw_dayTomorrow = 'Fredag'; this.sw_dayThirdday = 'Lørdag'; this.sw_dayFourthday = 'Søndag'; this.sw_dayFifthday = 'Mandag'; this.sw_daySixthday = 'Tirsdag'; this.sw_daySeventhday = 'Onsdag' }
    else if (sw_thisday === 5) { this.sw_day = 'Fredag'; this.sw_dayTomorrow = 'Lørdag'; this.sw_dayThirdday = 'Søndag'; this.sw_dayFourthday = 'Mandag'; this.sw_dayFifthday = 'Tirsdag'; this.sw_daySixthday = 'Onsdag'; this.sw_daySeventhday = 'Torsdag' }
    else if (sw_thisday === 6) { this.sw_day = 'Lørdag'; this.sw_dayTomorrow = 'Søndag'; this.sw_dayThirdday = 'Mandag'; this.sw_dayFourthday = 'Tirsdag'; this.sw_dayFifthday = 'Onsdag'; this.sw_daySixthday = 'Torsdag'; this.sw_daySeventhday = 'Fredag' }
    else if (sw_thisday === 0) { this.sw_day = 'Søndag'; this.sw_dayTomorrow = 'Mandag'; this.sw_dayThirdday = 'Tirsdag'; this.sw_dayFourthday = 'Onsdag'; this.sw_dayFifthday = 'Torsdag'; this.sw_daySixthday = 'Fredag'; this.sw_daySeventhday = 'Lørdag' };

    var sw_mm = sw_date.getMonth()+1;

    this.sw_dateNumber = sw_dd+'.'+sw_mm;
    //Tomorrows date showed in table
    var sw_to = new Date();
    sw_to.setDate(sw_to.getDate()+8);
    var sw_tomorrow_dd = sw_to.getDate();
    var sw_tomorrow_mm = sw_to.getMonth()+1;
    var sw_tomorrowsDateNumber = sw_tomorrow_dd+'.'+sw_tomorrow_mm;
    this.sw_dateNumberTomorrow = sw_tomorrowsDateNumber;
    //Third days date showed in table
    var sw_th = new Date();
    sw_th.setDate(sw_th.getDate()+9);
    var sw_th_dd = sw_th.getDate();
    var sw_th_mm = sw_th.getMonth()+1;
    var sw_thDateNumber = sw_th_dd+'.'+sw_th_mm;
    this.sw_dateNumberThirdday = sw_thDateNumber;
    //Fourth days date showed in table
    var sw_fh = new Date();
    sw_fh.setDate(sw_fh.getDate()+10);
    var sw_fh_dd = sw_fh.getDate();
    var sw_fh_mm = sw_fh.getMonth()+1;
    var sw_fhDateNumber = sw_fh_dd+'.'+sw_fh_mm;
    this.sw_dateNumberFourthday = sw_fhDateNumber;
    //Fifth date showed in table
    var sw_fi = new Date();
    sw_fi.setDate(sw_fi.getDate()+11);
    var sw_fi_dd = sw_fi.getDate();
    var sw_fi_mm = sw_fi.getMonth()+1;
    var sw_fiDateNumber = sw_fi_dd+'.'+sw_fi_mm;
    this.sw_dateNumberFifthday = sw_fiDateNumber;
    //Sixth date showed in table
    var sw_si = new Date();
    sw_si.setDate(sw_si.getDate()+12);
    var sw_si_dd = sw_si.getDate();
    var sw_si_mm = sw_si.getMonth()+1;
    var sw_siDateNumber = sw_si_dd+'.'+sw_si_mm;
    this.sw_dateNumberSixthday = sw_siDateNumber;

    var sw_sev = new Date();
    sw_sev.setDate(sw_sev.getDate()+13);
    var sw_sev_dd = sw_sev.getDate();
    var sw_sev_mm = sw_sev.getMonth()+1;
    var sw_sevDateNumber = sw_sev_dd+'.'+sw_sev_mm;
    this.sw_dateNumberSeventhday = sw_sevDateNumber;
  },
  computed: {
    workouts_sorted_time: function() {
      return _.orderBy(this.workouts, 'time')
    },
    workouts_sorted_type: function() {
      return _.orderBy(this.workouts, 'type')
    }
  }

}

</script>


<style>

li{
  font-size: 25px;
}

.column.cities {
  width: 100px;
}

div.column.is-one-quarter.classes {
  box-shadow: 0px 8px 18px rgba(0, 0, 0, 0.05);
  border-radius: 6px;
  width: 200px;
}
div.column.is-one-quarter.classes:hover {
  box-shadow: 0px 9px 24px rgba(0, 0, 0, 0.10);
  transition: all 0.3s
}

div.container.taster-cities{
  margin-right: 500px;
  margin-left: 500px;
  width: 600px;
}
div.tabs.taster-cities{
  width: 600px;
}



.workout-type {
  font-size: 16px;
  border-radius: 0px;

}

.workout-type.is-active {
  border-width: 8px;
  border-color: #15C0BA;
  justify-content: center;
  text-align: center;
}
.workout-type.is-active:hover {
  border-width: 9px;
  border-color: #15C0BA;
}
.workout-type:hover {
  border-width: 3px;
  border-color: #15C0BA;
  transition: 0.2s;
}

.workout-date.is-active {
  font-family: 'Helvetica Neue';
  color: #15C0BA;
}
.workout-date {
  font-family: 'Helvetica Neue';
  font-size: 16px;
}

#workout-table {
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

#workout-name{
  color: #3a3a3a;
  font-size: 16px;
}
#workout-type {
  color: #3a3a3a;
  font-size: 15px;
}
#workout-places {
  color: #3a3a3a;
  font-size: 14px;
}

div.panel-body {
  padding-left: 100px;
  padding-right: 100px;
}

#meldon {
  background-color: #15C0BA;
  color: white;
  border-width: 0px;
  border-radius: 1px;
}
#meldon:hover {
  background-color: #5AAFAD;
  color: white;
  border-width: 0px;
  border-radius: 1px;
  box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.1);
  transition: all 0.5s
}

.button.search{
  background-color: #15C0BA;
  font-family: 'Helvetica Neue';
}

#btn-weeks{
  border-color: transparent;
  color: grey;
  font-size: 14px;
}

#workout-time{

}
#workout-name{
  width: 150px;

}
#workout-type{
  width: 150px;
}
#workout-studio{
  width: 200px;
}
#workout-places{

}

</style>



// WEBPACK FOOTER //
// src/components/Classes_overview.vue